import React, {  useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../Drone.module.scss';
import metadata from './DroneInformationComponent.metadata.json5';
import UASTableComponent from '../subcomponents/UASTable/UASTableComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function DroneInformationComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('DroneInformationComponent');
const modelVM = _.get(submissionVM, pathUpdated);

modelVM.value.isValidationReq = true;

const getTotalHullValue = () => {
    const uasTableData = _.get(modelVM.value, 'uastable');

    let totalHullValue = 0;

    if (uasTableData.length > 0) {
        uasTableData.map((uasData) => {
            if (uasData.insHulVal !== undefined) {
                totalHullValue += uasData.insHulVal;
            }
        })
        _.set(modelVM, 'totInsVal.value', totalHullValue);
    }

    return totalHullValue;
}

// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        uasComponent: {
            data: modelVM.uastable,
            updateWizardData,
            submissionVM,
            UASTablePath: `${pathUpdated}.uasTable`
        },
        totInsVal: {
            value: getTotalHullValue()
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            uasComponent: UASTableComponent
        },
        resolveClassNameMap: styles
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

DroneInformationComponent.propTypes = wizardProps;
export default withRouter(DroneInformationComponent);
